import { render, staticRenderFns } from "./ExchangeProduct.vue?vue&type=template&id=4f1fdfc4&scoped=true"
import script from "./ExchangeProduct.vue?vue&type=script&lang=js"
export * from "./ExchangeProduct.vue?vue&type=script&lang=js"
import style0 from "./ExchangeProduct.vue?vue&type=style&index=0&id=4f1fdfc4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1fdfc4",
  null
  
)

export default component.exports